/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Volume_ElevationInputs */

const en_ui_volume_elevation = /** @type {(inputs: Ui_Volume_ElevationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elevation`)
};

const de_ui_volume_elevation = /** @type {(inputs: Ui_Volume_ElevationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höhenmeter`)
};

/**
* | output |
* | --- |
* | "Elevation" |
*
* @param {Ui_Volume_ElevationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_volume_elevation = /** @type {((inputs?: Ui_Volume_ElevationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Volume_ElevationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_volume_elevation(inputs)
	return de_ui_volume_elevation(inputs)
});